define('../app/fukit/helpers/route.helper',['require','exports','module','backbone','underscore','handlebars','backbone.radio','bluebird'],function(require, exports, module) {
  //prettier-ignore
  var Backbone   = require('backbone'),
      _          = require('underscore'),
      Handlebars = require('handlebars'),
      Radio      = require('backbone.radio'),
      Promise    = require('bluebird');

  var RouteHelper = Backbone.Model.extend({
    constructor: function(routeName) {
      this.routeName = routeName;
      this.attributes = {};
      this.changed = {};
      this.ignoredKeys = [];
      this.models = [];
      _.each(_.rest(arguments), this.add, this);
      this.updateLink();
    },

    removeAll: function() {
      var models = _.clone(this.models);
      for (var i = 0, len = models.length, model; i < len; i++) {
        model = models[i];
        this.stopListening(model.model);
      }
      this.models = [];
      this.updateLink();
      return this;
    },

    add: function(model, mapping) {
      model = model instanceof Backbone.Model ? model : new Backbone.Model(model);
      this.models.push({
        model: model,
        mapping: mapping,
      });
      this.listenTo(model, 'change', this.updateLink);
      this.updateLink();
      return this;
    },

    link: function() {
      return this.get('link');
    },

    ignore: function(key) {
      this.ignoredKeys.push(key);
      this.updateLink();
      return this;
    },

    updateLink: function() {
      var params = {};
      _.each(this.models, function(item) {
        if (item.mapping) {
          _.each(item.mapping, function(src, dest) {
            params[dest] = item.model.get(src);
          });
        } else {
          _.extend(params, item.model.toJSON());
        }
      });
      this.set('link', this.constructor.resolve(this.routeName, _.omit(params, this.ignoredKeys)));
      return this;
    },
  });

  RouteHelper.map = {};

  RouteHelper.defaltParams = {};

  /**
   * Navigate to a new route in application, set state attributes
   * @param  {String} routeName name of the route w/o params
   * @param  {Object} params    url params, sets params on PageState
   * @param  {Object} options   routing options (see backbonejs router.navigate)
   * @return {void}
   */
  RouteHelper.navigate = function(routeName, params, options) {
    options = options || {};
    // get state
    var state = Radio.channel('AppKit.controllerService').request('state');
    // update the routeName for  on the controllerService
    Radio.channel('AppKit.controllerService').request('updateRouteName', routeName);

    // if in the context of standard cayuse app
    if (state && !options.trigger) {
      // silent = don't trigger state change event (which triggers route update)
      state.set(params);
    }

    Backbone.history.navigate(RouteHelper.resolve(routeName, params), options);
  };

  RouteHelper.linkFormatGenerator = function(routeName, mapping) {
    return function(model) {
      var routeHelper = new RouteHelper(routeName).add(model, mapping);
      return routeHelper.get('link');
    };
  };

  RouteHelper.createLink = function(routeName, model, mapping) {
    return RouteHelper.resolve.apply(this, arguments);
  };

  RouteHelper.setDefaultParams = function(name, params) {
    RouteHelper.defaltParams[name] = _.extend({}, RouteHelper.defaltParams[name], params);
    return this;
  };

  RouteHelper.getDefaultParams = function(name) {
    return _.extend({}, RouteHelper.defaltParams[name]);
  };

  RouteHelper.setStaticRoot = function(root) {
    RouteHelper.staticRoot = root;
    return this;
  };

  RouteHelper.resolve = function(name, params) {
    if (arguments.length > 2 || params instanceof Backbone.Model) {
      var routeHelper = new RouteHelper(name).add(params, arguments[2]);
      return routeHelper.get('link');
    }
    var router = this.map[name];
    if (!router) {
      Promise.reject(new Error('There is no router for the route named "' + name + '".'));
      return '';
    }
    if (!router.resolve) {
      Promise.reject(
        new Error('The registred router for the route named "' + name + '" does not support route resolving."')
      );
      return '';
    }
    return (RouteHelper.staticRoot || '#') + router.resolve(name, _.extend(RouteHelper.getDefaultParams(name), params));
  };

  RouteHelper.register = function(router) {
    if (_.isObject(router._routeNames)) {
      _.each(
        router._routeNames,
        function(route, name) {
          this.map[name] = router;
        },
        this
      );
    }
  };

  (function() {
    //prettier-ignore
    var currentRouteFragment,
        previousRouteFragment,
        currentRouteName,
        previousRouteName;
    RouteHelper.getPreviousFragment = function() {
      return previousRouteFragment;
    };
    RouteHelper.getPreviousRouteName = function() {
      return previousRouteName;
    };
    RouteHelper.navigatePrevious = function(options) {
      Backbone.history.navigate(previousRouteFragment, _.extend({ trigger: true }, options));
    };
    Backbone.history.on('route', function(router, routeName) {
      previousRouteName = currentRouteName;
      currentRouteName = routeName;
      previousRouteFragment = currentRouteFragment;
      currentRouteFragment = Backbone.history.fragment;
    });
  })();

  Handlebars.registerHelper('routeLink', function(name) {
    return '#' + RouteHelper.resolve(name);
  });

  module.exports = RouteHelper;
});

